import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import merge from 'lodash/merge';
import queryString from 'qs';
import { CalendarAddIcon } from '@domain-group/fe-co-icon';
import { getShortDayAndDate, getTime } from '@domain-group/fe-allhomes-library';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import * as styles from './next-event.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var getCalendarGeneratorOptions = inspection => {
  var options = {
    startDate: inspection.startDate,
    endDate: inspection.endDate
  };
  var address = get(inspection, 'location.address');
  if (address) {
    var url = address.url,
      price = address.price,
      beds = address.beds,
      baths = address.baths,
      parking = address.parking,
      streetAddress = address.streetAddress,
      addressLocality = address.addressLocality;
    var location = "".concat(streetAddress, ", ").concat(addressLocality);
    merge(options, {
      url,
      price,
      beds,
      baths,
      parking,
      location
    });
  }
  return queryString.stringify(options);
};
var NextEvent = _ref => {
  var headingText = _ref.headingText,
    inspection = _ref.inspection,
    calendarGeneratorUrl = _ref.calendarGeneratorUrl;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var downloadCalendar = () => {
    if (inspection) {
      sendEvent('calendar-click', {
        text: "".concat(headingText, ": ").concat(getShortDayAndDate(inspection.startDate), " ").concat(getTime(inspection.startDate))
      });
      window.location = "".concat(calendarGeneratorUrl, "?").concat(getCalendarGeneratorOptions(inspection));
    }
  };
  return ___EmotionJSX("div", {
    css: styles.nextEvent
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, headingText, ": "), ___EmotionJSX("div", {
    css: styles.body
  }, inspection && ___EmotionJSX("div", {
    css: styles.inspection
  }, ___EmotionJSX("div", {
    css: styles.item
  }, ___EmotionJSX("a", {
    css: styles.itemLeft
  }, ___EmotionJSX("span", {
    itemProp: "name"
  }, getShortDayAndDate(inspection.startDate)), ___EmotionJSX("div", {
    css: styles.itemTime
  }, ___EmotionJSX("span", {
    itemProp: "startDate",
    content: inspection.startDate
  }, getTime(inspection.startDate))))))), ___EmotionJSX("div", {
    css: styles.buttons
  }, ___EmotionJSX("button", {
    type: "button",
    title: "Click to download calendar file",
    css: styles.itemButton,
    onClick: downloadCalendar,
    "aria-label": "downloadCalendar"
  }, ___EmotionJSX(CalendarAddIcon, {
    size: "regular"
  }))));
};
NextEvent.propTypes = {
  headingText: PropTypes.string,
  inspection: PropTypes.shape({
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string
  }),
  calendarGeneratorUrl: PropTypes.string
};
NextEvent.defaultProps = {
  headingText: 'Next Inspection',
  inspection: null,
  calendarGeneratorUrl: '/listing-event'
};
export default NextEvent;